// extracted by mini-css-extract-plugin
export default {"header":"A7QcS","header__left":"gdcDH","header__left-switch":"rBfBq","header__leftSwitch":"rBfBq","header__right":"Dc6AK","appear-from-above":"HpMUW","appearFromAbove":"HpMUW"};